<template>
  <div style="width: 100%;height: 100%;overflow: hidden;color: white">
    <div class="nothing-data" v-if="list.length === 0"></div>
    <div v-else style="height: 100%;width: 100%;margin: auto" id="bar" ref="wrap"></div>
  </div>
</template>

<script>
// import echarts from 'echarts'
import * as echarts from 'echarts'
export default {
  name: 'indexSendOrder',
  props: {
    orderlist: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      list: [],
      servicetypename: [],
      orderArr: [], // 派单数量
      doneOrder: [] // 完成数量
    }
  },
  mounted () {
    // 派单&完成数量
    this.getStartData()
  },
  methods: {
    getRefresh (arr) {
      // console.log('派单&完成数量', arr)
      this.list = arr
      this.getStartData()
    },
    getStartData () {
      this.orderArr = []
      this.doneOrder = []
      this.servicetypename = []
      for (let i = 0; i < this.list.length; i++) {
        let aa = this.list[i].servicecount !== '' ? parseFloat(this.list[i].servicecount) : 0
        let bb = this.list[i].servicecompletecount !== '' ? parseFloat(this.list[i].servicecompletecount) : 0
        this.orderArr.push(aa)
        this.doneOrder.push(bb)
        this.servicetypename.push(this.list[i].servicetype)
      }
      // console.log(this.orderArr)
      // console.log(this.doneOrder)
      // console.log(this.servicetypename)
      let vm = this
      setTimeout(() => {
        if (this.list.length > 0) {
          vm.getChartData()
        }
      }, 100)
    },
    getChartData () {
      let chart = this.$echarts.init(this.$refs.wrap)
      chart.setOption({
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          top: '3%',
          left: '4%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        legend: {
          data: ['派单数量', '完成数量'],
          textStyle: {
            color: '#ffffff'
          }
        },
        xAxis: [
          {
            type: 'category',
            axisLine: {
              lineStyle: {
                color: '#7fd4ff',
                width: 1
              }
            },
            data: this.servicetypename,
            axisPointer: {
              type: 'shadow'
            },
            axisLabel: { // X轴文字倾斜
              interval: 0,
              rotate: 20
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLine: {
              lineStyle: {
                color: '#7fd4ff',
                width: 1 // 这里是为了突出显示加上的
              }
            },
            name: '',
            min: 0,
            // max: 250,
            // interval: 50,
            axisLabel: {
              formatter: '{value}'
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#182f4d',
                width: 1 // 这里是为了突出显示加上的
              }
            }
          }
        ],
        series: [
          {
            name: '派单数量',
            type: 'bar',
            data: this.orderArr,
            barWidth: 8,
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0, 0, 0, 1,
                  [
                    {offset: 0, color: '#0073e5'},
                    {offset: 1, color: '#00aaff'}
                  ]
                )
              }
            }
          },
          {
            name: '完成数量',
            type: 'bar',
            data: this.doneOrder,
            barWidth: 8,
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0, 0, 0, 1,
                  [
                    {offset: 0, color: '#ffd400'},
                    {offset: 1, color: '#ff9500'}
                  ]
                )
              }
            }
          }
        ],
        dataZoom: [
          {
            type: 'slider',
            show: true
            // start: 0,
            // end: 49,
            // textStyle: {
            //   color: '#ccd7d7'
            // }
          }
        ]
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/monitoring/bigComponents/indexSendOrder.vue